import { useAuth } from '../Auth/Login/auth';

/* eslint-disable */
function Info(props) {
    const {
        buttons =[],
        fieldMap = {},
        data = {},
        specialFields = {},
        heading={},
    } = props;
    const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
    return (
        <div className='p-6 relative top-4'>
            <div className='flex gap-4 items-center justify-between align-center'>
                <div className='flex gap-5 items-center align-center'>
                    {heading?.key && (                    
                    <h2 className='text-xl font-semibold'>{heading?.key}:</h2>
                    )}
                    <div className='text-gray-600 text-[16px]'><strong>{heading?.value}</strong> </div>
                </div>
                <div className='flex gap-2'>
                    {buttons?.map((button, index) => {
                        if (button?.noLevelSpecific || levels.includes(level)) {
                            return (
                            <button key={index} 
                                className={`
                                    flex items-center justify-center 
                                    px-4 py-2 
                                    gap-2
                                    text-sm font-medium 
                                    rounded-md border
                                    transition-colors duration-200
                                    ${button?.style}
                                    ${button?.disabled ? 'opacity-50 cursor-not-allowed' : ''}
                                `}
                                onClick={button?.handleClick}
                                disabled={button?.disabled}
                            >
                                {button?.icon}
                                {button?.label}
                            </button>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>

            <div className='grid grid-cols-5 gap-4 mt-5 mb-5 text-gray-700 '>
                {Object.entries(fieldMap).map(([key, value]) => {
                    const dataValue = data[value];
                    const id = data?.id;
                    return (
                        <div >
                            <p className='text-[12px] font-medium'>{key}</p>
                            {specialFields[key] ? specialFields[key](id , dataValue) : <p className='text-[14px] font-semibold'>{dataValue}</p>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Info;


